export const isDesktop = (breakpoints, breakpointFlags) => {
  for (let i = 0; i < breakpoints.length; ++i) {
    if (breakpoints[i] === 768) return breakpointFlags[i];
  }
  throw new Error('768 must be a breakpoint included.');
};

export const getPopupMedia = (webPopup, breakpoints, breakpointFlags) => {
  if (isDesktop(breakpoints, breakpointFlags)) {
    if (webPopup.image) return webPopup.image.desktop_img_url;
    return webPopup.video.desktop_video_url;
  }
  if (webPopup.image) return webPopup.image.mobile_img_url;
  return webPopup.video.mobile_video_url;
};
